import axios from 'axios';
import qs from 'qs';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_RESTLET_FUNCTION_BASE_URL,
});

export const lookupSale = async (sale) =>
  (await axiosInstance.get(`restlet?${qs.stringify(sale)}`)).data;

export const requestInvoice = async (requestBody) =>
  (await axiosInstance.post('restlet', requestBody)).data;
